<template>
  <el-form :model="passForm" :rules="passRules" ref="passForm" class="set_form" v-loading="disabled">
    <div class="passDiv">
      <el-form-item :label="$t('colon.oidPwd')" class="info_box" prop="oldpass">
        <el-input type="password" class="info_ipt" v-model="passForm.oldpass" show-password autocomplete="off" minlength='6' maxlength='20'  @input="forbidInput('oldpass')"></el-input>
      </el-form-item>
    </div>
    <div class="passDiv">
      <el-form-item :label="$t('colon.newPwd')" class="info_box" prop="pass">
        <el-input type="password" class="info_ipt" v-model="passForm.pass" show-password autocomplete="off" minlength='6' maxlength='20'  @input="forbidInput('pass')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('colon.enterPwdAgain')" class="info_box" prop="checkPass">
        <el-input type="password" class="info_ipt" v-model="passForm.checkPass" show-password autocomplete="off" minlength='6' maxlength='20'  @input="forbidInput('checkPass')"></el-input>
      </el-form-item>
    </div>
    <div class="set_btn">
      <el-button :disabled='disabled' @click="resetForm('passForm')">{{$t('base.cancel')}}</el-button>
      <el-button :disabled='disabled' type="primary" @click="submitForm('passForm')">{{$t('base.save')}}</el-button>
    </div>
  </el-form>
</template>
<script>
import { isEmoji } from "@/api/public";
import VueCookie from "vue-cookie";
export default {
  name: 'passwordbox',
  data() {
    var oldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.oldPwd'))); //请输入密码
      } else {
        callback();
      }
    };
    var newPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.newPwd'))); //请输入密码
      } else {
        if (this.passForm.checkPass !== '') {
          this.$refs.passForm.validateField('checkPass');
        }
        callback();
      }
    };
    var newPassAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.newPwdAgain')));
      } else if (value !== this.passForm.pass) {
        callback(new Error(this.$t('rules.pwdTwiceIncorrect')));
      } else {
        callback();
      }
    };
    var numSix=(rule, value, callback)=>{
      if (value.length>0&&value.length<6) {
        callback(new Error(this.$t('rules.pwdCharacterRule'))); 
      } else {
        callback();
      }
    };
    return {
      disabled:false,
      passForm: {
        oldpass: '',
        pass: "",
        checkPass: ""
      },
      passRules: {
        oldpass: [{ required: true, message: this.$t('rules.oldPwd'), trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
        ],
        pass: [
          { validator: newPass, trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('rules.pwdRule'), trigger: 'blur' },
          //{ pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: 'Password should contain at least 1 uppercase letter and 1 number',trigger: 'blur'},
        ],
        checkPass: [
          { validator: newPassAgain, trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('rules.pwdRule'), trigger: 'blur' },
          //{ pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: 'Password should contain at least 1 uppercase letter and 1 number',trigger: 'blur'},
        ],
      }
    }
  },
  props: {
    list: Object,
  },
  inject: ['reload'],
  methods: {
    forbidInput(e) {
      let num=1
      this.ruleForm[e] = isEmoji(this.ruleForm[e], num)
    },
    submitForm(formName) {
      let that = this;
      let userLog = that.$store.state.userLog;
      //console.log(userLog)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          var data = { 'memberId': that.list.Id, 'oldPassword': that.passForm.oldpass, 'newPassword': that.passForm.pass }
          that.$post(that.$interface.ChangePassword, data).then(res => {
            //console.log(res)
            that.$emit('getData', that.list, 'password')
            that.Logout();
            this.$router.push({ path: '/login'})
          })
        }
      });
    },
    resetForm(formName) {
      let that = this;
      that.$refs[formName].resetFields();
      that.$emit('getData', this.list, 'password')
    },
    Logout() {
      // window.localStorage.removeItem('cardUser');
      VueCookie.delete("cardUser");
      this.reload()
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/settings.css";

.passDiv {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/form/password.vue